import axiosInstance from './authService.js';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_BASE_URL = `${BASE_URL}/api/ai`  

export const getAIResponse = async (message, design, designId) => {
	try {
		const response = await axiosInstance.post(`${API_BASE_URL}/chat/`, {
			message: message,
			design: design,
			designId: designId
			});
		return response.data.response;  //  Extract the text response
	} catch (error) {
		console.error("Error fetching AI chat response:", error.response?.data || error.message);
		throw error;
	}
};
   
export const getAIConfigs = async (message, design, designId) => {
    try {
        const response = await axiosInstance.post(`${API_BASE_URL}/configs/`, {
			message: message,
			design: design,
			designId: designId
			});
        return response.data.response;  //  Access the 'response' key
    } catch (error) {
        //  Consider more specific error handling here
        console.error("Error fetching AI configs:", error);
        throw new Error("Failed to fetch AI configurations.");
    }
};